import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDiamondStarFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M12 2.25C12.3251 2.25 12.6136 2.45932 12.7139 2.76855C14.0239 6.80856 17.1914 9.97608 21.2314 11.2861C21.5407 11.3864 21.75 11.6749 21.75 12C21.75 12.3251 21.5407 12.6136 21.2314 12.7139C17.1914 14.0239 14.0239 17.1914 12.7139 21.2314C12.6136 21.5407 12.3251 21.75 12 21.75C11.6749 21.75 11.3864 21.5407 11.2861 21.2314C9.97608 17.1914 6.80856 14.0239 2.76855 12.7139C2.45932 12.6136 2.25 12.3251 2.25 12C2.25 11.6749 2.45932 11.3864 2.76855 11.2861C6.80856 9.97608 9.97608 6.80856 11.2861 2.76855L11.333 2.65723C11.4598 2.41022 11.7157 2.25 12 2.25Z",
		fill: "url(#paint0_linear_11478_100913)"
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_11478_100913",
		x1: 21.75,
		y1: 12,
		x2: 2.25,
		y2: 12,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#F43F5E" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#6366F1"
		})]
	}) })]
});
export default SvgDiamondStarFill;
